import React from 'react';
import { Outlet } from 'react-router-dom';
import MainPanel from './MainPanel';
import Sidebar from './Sidebar';
import '../components/dashboard/NewLookDashboard.css';

export default function AppLayout() {
  return (
    <div className="hmisx">
      <Sidebar />
      <MainPanel>
        <Outlet />
      </MainPanel>
    </div>
  );
}
